/* istanbul ignore file */
import { v4 as uuidv4 } from 'uuid'

const buildDynamicFilterRequest = ({ searchRequest, activeTabId = 1, staticFilters }) => {
  const { originAirport, destinationAirport, travelDate } = searchRequest.slices[activeTabId - 1]
  return {
    input: {
      client: 'PCLN_FLIGHTS',
      requestId: `${uuidv4()}-dynamic-filters`,
      slices: [
        {
          sliceId: activeTabId,
          origins: [
            {
              location: originAirport,
              type: 'AIRPORT',
            },
          ],
          destinations: [
            {
              location: destinationAirport,
              type: 'AIRPORT',
            },
          ],
          departDate: travelDate,
        },
      ],
      staticFilters,
      appCode: 'DESKTOP',
    },
  }
}

export { buildDynamicFilterRequest }
